import React, { useState } from 'react';
import { Container, Wrapper, Title, Desc, CardContainer } from './EventsStyle';
import ProjectCard from '../Cards/ProjectCards';
import { projects } from '../../data/constants';

const Projects = ({ openModal, setOpenModal }) => {
  const [toggle, setToggle] = useState('all');

  const filteredProjects = toggle === 'all' ? projects : projects.filter((item) => item.category === toggle);

  return (
    <Container id="events">
      <Wrapper>
        <Title>Events</Title>
        <Desc>
          Explore Our Events and Register Now!
        </Desc>

        <CardContainer>
          {filteredProjects.map((project) => (
            <ProjectCard key={project.id} project={project} openModal={openModal} setOpenModal={setOpenModal} />
          ))}
        </CardContainer>
        
      </Wrapper>
    </Container>
  )
};

export default Projects;
